<template>
  <div class="collapsible-list">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    methods: {
      closeAll(senderChild) {
        this.$children.forEach((child) => {
          if (child !== senderChild) {
            child.close();
          }
        });
      }
    }
  }
</script>
